<template>
  <div>
    <h3>新增寻样申请</h3>
    <OutsideApplySample ref="outsideApplySample" @on-success="cancelBtn" @cancel-btn="cancelBtn" />
  </div>
</template>
<script>
import OutsideApplySample from '@/components/OutsideApplySample';

export default {
  components: {
    OutsideApplySample,
  },
  props: {
    removeTab: {
      type: Function,
      default: null,
    },
  },
  computed: {},
  data: () => ({
    saveLoading: false,
  }),
  mounted() {},
  methods: {
    getDetail() {
      this.$nextTick(() => {
        this.$refs.outsideApplySample.resetForm();
      })
    },
    cancelBtn() {
      this.removeTab('bill');
    },
  },
};
</script>
<style lang="less" scoped>
h3 {
  text-align: center;
}
</style>